export const APPLICATION_JSON = 'application/json'

export const POST = 'POST'
export const PUT = 'PUT'
export const DELETE = 'DELETE'

export const STRAPI_ABOUT_US = 'about-us'
export const STRAPI_API = 'strapi'
export const STRAPI_ARTICLE = 'articles'
export const STRAPI_CONTACT = 'contact'
export const STRAPI_HOME = 'home'
export const STRAPI_MAIN_MENU = 'main-menu'
export const STRAPI_PAGE = 'pages'
export const STRAPI_PROMOTIONS = 'promotions'
export const STRAPI_CUSTOMERS = 'customers'
export const STRAPI_CUSTOMER_CONTRACTS = 'customer-contacts'
export const STRAPI_REASON = 'reason'
export const STRAPI_REVIEWS = 'reviews'
export const STRAPI_SERVICES = 'services'
export const STRAPI_SOCIAL_MEDIA = 'social-media'
export const STRAPI_EMAIL = 'email'

export const INTERNAL_IMAGE = 'image'

export const INTERNAL_SEND_EMAIL = 'send-email'
